module.exports = __webpack_public_path__ + "img/calendar-stroke.4102032f.png";